import React from "react";

export default function Contacts({ }) {
    return (<React.Fragment>
        <h1>CONTACTS</h1>

    </React.Fragment>)
}